import api from "../api";
export default {
  namespaced: true,
  state: {
    staticText: {},
    faq: {}
  },
  getters: {
    
  },
  actions: {

    async get_static_text({ commit }, code) {
      try {
          api.get("/v1/static_text/"+code)
          .then((res) => {
            commit("GET_STATIC_TEXT", res.data);
          })
          .catch((error) => {
            commit("ERROR_STATIC_TEXT", error);
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_STATIC_TEXT", e);
      }
    },

    async get_faqs({ commit }) {
      try {
          api.get("/v1/faq")
          .then((res) => {
            commit("GET_FAQ", res.data);
          })
          .catch((error) => {
            commit("ERROR_STATIC_TEXT", error);
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_STATIC_TEXT", e);
      }
    },

    
    
  },
  mutations: {
    GET_STATIC_TEXT(state, data) {
      state.staticText = data
    },
    GET_FAQ(state, data) {
      state.faq = data
    },
    ERROR_STATIC_TEXT(state, data) {
      console.log(data)
    }
  }
}